import { useEffect } from 'react';
import { useAgentStore, useAuthStore, useChatInputStore } from '@/store';

export default function useDefaultChatBot(enabled) {
  const defaultId = useAuthStore(state => state.user?.defaultAgentId);
  const isPlus = useAuthStore(state => state.user?.flags?.isPlus);
  const bot = useAgentStore(state => state.agents[defaultId]);
  const input = useChatInputStore(state => state.inputStates.new);
  const contextId = useChatInputStore(state => state.currentContextId);

  useEffect(() => {
    if (!enabled || !defaultId || bot) return;
    void useAgentStore.getState().fetchAgentById(defaultId).catch(() => {});
  }, [enabled, defaultId, bot]);

  useEffect(() => {
    if (!enabled || !bot || bot.flags?.isEnabled === false || (bot.flags?.isPlusOnly && !isPlus)) return;
    const composer = useChatInputStore.getState();
    const draft = composer.inputStates.new;
    // Defaults only seed an untouched, empty composer. Clearing a bot is an
    // explicit choice; model/tool handoffs and existing drafts keep their target.
    if (composer.currentContextId !== 'new' || !draft || composer.pendingAutoSend
      || draft.agentSelectionTouched || draft.modelSelectionTouched
      || draft.selectedAgentIds?.length || draft.text?.trim() || draft.files?.length) return;
    composer.setSelectedAgents([bot.id], { botId: bot.id });
  }, [enabled, defaultId, bot, isPlus, input, contextId]);
}
